import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const ContentContext = createContext({ content: null, services: [], talks: [], posts: [], loading: true, refresh: () => {} });

export function ContentProvider({ children }) {
  const [state, setState] = useState({ content: null, services: [], talks: [], posts: [], loading: true });

  const refresh = useCallback(async () => {
    try {
      // cache-bust so a user returning to a stale tab always gets fresh content
      const { data } = await api.get(`/content?t=${Date.now()}`);
      setState({
        content: data.content,
        services: data.services || [],
        talks: data.talks || [],
        posts: data.posts || [],
        loading: false,
      });
    } catch (e) {
      setState((s) => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => {
    refresh();
    const onFocus = () => refresh();
    const onVis = () => {
      if (document.visibilityState === "visible") refresh();
    };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVis);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ ...state, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
